<template>
  <div
    class="col-md-12"
    style="height: 100%"
  >
    <div class=" card_add form-group">
      <p>
      <span
        class=" manage_btn col-lg-5 mdi mdi-plus-circle-outline btn btn-success btn-fill"
        @click.prevent="new_IPS({})"
      >{{ translate('ip_profile.add') }}</span> <br>
    </p>
    </div>
    <div class="row response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col" style="width: 40px">
              ID
            </th>
            <th scope="col">
              {{ translate('ip_profile.name') }}
            </th>
            <th scope="col">
              {{ translate('ip_profile.name_short') }}
            </th>
            <th scope="col">
              IP
            </th>
            <th scope="col">
              {{ translate('ip_profile.ports') }}
            </th>
            <th scope="col">
              {{ translate('ip_profile.by_ports') }}
            </th>
            <th scope="col">
              {{ translate('min') }}
            </th>
            <th scope="col">
              {{ translate('max') }}
            </th>
            <th scope="count">
              {{ translate('ip_profile.devices_count') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(ip,key) in ips"
            :key="key"
            @click.prevent="new_IPS(ip)"
            class="ip_item"
          >
            <td
              data-label="ID"
              style="width: 40px"
            >
              {{ ip.id }}
            </td>
            <td :data-label="translate('ip_profile.name')">
              {{ ip.name }}
            </td>
            <td :data-label="translate('ip_profile.name_short')">
              {{ ip.short_name }}
            </td>
            <td data-label="IP">
              {{ ip.ip }}
            </td>
            <td :data-label="translate('ip_profile.ports')">
              {{ ip.ports }}
            </td>
            <td :data-label="translate('ip_profile.by_ports')">
              {{ ip.by_ports }}
            </td>
            <td :data-label="translate('min')">
              {{ ip.min }}
            </td>
            <td :data-label="translate('max')">
              {{ ip.max }}
            </td>
            <td :data-label="translate('ip_profile.devices_count')">
              {{ ip.devices_count }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EditIPS from './EditIps'
export default {
  name: 'IpsList',
  components: {
    //  EditIPS
  },
  data () {
    return {ips: {}}
  },
  mounted () {
    this.$http.v1.getIPS((response) => { this.ips = response.data })
  },
  methods: {
    new_IPS (val) {
      var t = this.$createElement(EditIPS, {props: {ips: val}, on: {close: () => { this.$modal.hide('dynamic-modal') }, update: (val) => { this.update(val) }}})
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', name: 'dynamic-modal'})
    },
    update (val) {
      this.$http.v1.saveIPS(val, () => {
        this.global_notify('info', this.translate('profile_saved'))
        this.$modal.hide('dynamic-modal')
        this.$http.v1.getIPS((response) => { this.ips = response.data })
      })
    }
  }
}
</script>

<style lang="scss" scope>
  .ip_item{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
  }
</style>
